import { createContext, useContext } from 'react';
export var agentOverrider = /*#__PURE__*/createContext({});
export var useAgentOverrider = function useAgentOverrider() {
  return useContext(agentOverrider);
};
export var AgentOverriderProvider = agentOverrider.Provider;
export { getOverridenAgents } from './utils';
export var createAgentsConfig = function createAgentsConfig(config) {
  return {
    agentDefaultIdOverride: config === null || config === void 0 ? void 0 : config.defaultAgentId,
    agentIdFiltersOverride: config === null || config === void 0 ? void 0 : config.filter
  };
};